import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CompleteOnboarding as View } from '@views';
import { trackEvent } from '@utils/mixpanel';
import { SUCCESS } from '@constants/requestPhase';
import { routes } from '@constants';
import { resetPhases } from '@store/company/duck';

const CompleteOnboarding = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { currentLocation } = useSelector(store => store.locationStore);
  const { submitCompanyOnboardingPhase } = useSelector(store => store.companyStore);

  useEffect(() => {
    if (submitCompanyOnboardingPhase === SUCCESS) {
      dispatch(resetPhases());
      history.push(routes.home);
    }
  }, [submitCompanyOnboardingPhase]);

  useEffect(() => {
    const pageTitle = 'Mindspace: Final Step';
    document.title = pageTitle;

    window.gtag('event', 'page_view', {
      page_title: pageTitle,
    });

    trackEvent('Page Viewed', {
      Page: 'Complete - Onboarding',
    });
  }, []);

  return <View direction={location?.state?.direction} location={currentLocation?.title} />;
};

export default CompleteOnboarding;
